<template>
  <div class="ele-body teacher-archives">
    <el-card shadow="never">
      <el-form :model="table.where" label-width="78px" class="ele-form-search"
        @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :md="4" :sm="12">
            <el-form-item label="教师姓名:">
              <el-input v-model.trim="table.where.teacherName" placeholder="请输入教师姓名" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="4" :sm="12">
            <el-form-item label="档案类型:">
              <el-select v-model="table.where.typeId" placeholder="请选择类型" clearable filterable class="ele-block">
                <el-option v-for="item in typeOptions" :key="item.id" :label="typeLabel(item)" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="4" :sm="12">
            <el-form-item label="状态:">
              <el-select v-model="table.where.status" placeholder="请选择状态" clearable class="ele-block">
                <el-option label="待审核" value="0" />
                <el-option label="已通过" value="1" />
                <el-option label="未通过" value="2" />
                <el-option label="已归档" value="3" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="4" :sm="12">
            <el-form-item label="档案编号:">
              <el-input v-model.trim="table.where.docNum" placeholder="请输入档案编号" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="4" :sm="12">
            <el-form-item label="文件名称:">
              <el-input v-model.trim="table.where.docName" placeholder="请输入文件名称" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="4" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon"
                @click="$refs.table.reload()">查询</el-button>
              <el-button @click="resetSearch">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <div class="ele-table-tool ele-table-tool-default">
        <el-button type="success" icon="el-icon-folder-checked" class="ele-btn-icon" size="small"
          :disabled="!choose.length" @click="archiveSelected">
          批量归档
        </el-button>
      </div>

      <ele-data-table ref="table" :config="table" :row-key="getRowKey" :choose.sync="choose">
        <template #default="{ index }">
          <el-table-column type="selection" width="45" align="center" fixed="left" :selectable="canSelectForArchive" />
          <el-table-column type="index" :index="index" width="45" align="center" />
          <el-table-column prop="teacherName" label="教师姓名" min-width="100" show-overflow-tooltip />
          <el-table-column prop="typeName" label="档案类型" min-width="120" show-overflow-tooltip />
          <el-table-column prop="docName" label="文件名称" min-width="170" show-overflow-tooltip />
          <el-table-column prop="docNum" label="档案编号" min-width="120" show-overflow-tooltip />
          <el-table-column prop="status" label="状态" width="90" align="center">
            <template #default="{ row }">
              <el-tag :type="statusType(row.status)" size="mini">{{ statusText(row.status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="提交时间" min-width="150" show-overflow-tooltip />
          <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip />
          <el-table-column fixed="right" label="操作" width="330" align="center" :resizable="false">
            <template #default="{ row }">
              <el-link type="primary" :underline="false" icon="el-icon-view" @click="viewArchive(row)">查看</el-link>
              <el-link v-if="isArchived(row)" type="primary" :underline="false" icon="el-icon-edit"
                @click="setDocNum(row)">编号</el-link>
              <el-link v-if="canSelectForArchive(row)" type="success" :underline="false" icon="el-icon-folder-checked"
                @click="archive(row)">
                归档
              </el-link>
              <el-popconfirm title="确定要删除此档案吗？" @onConfirm="deleteArchive(row)" class="ele-action">
                <el-link slot="reference" type="danger" :underline="false" icon="el-icon-delete">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>

    <el-dialog title="教师档案详情" :visible.sync="detailVisible" width="650px" :destroy-on-close="true"
      custom-class="ele-dialog-form">
      <div v-if="currentArchive" class="archive-detail">
        <el-form label-width="90px">
          <el-form-item label="教师姓名:">
            <span>{{ currentArchive.teacherName || '-' }}</span>
          </el-form-item>
          <el-form-item label="档案类型:">
            <span>{{ currentArchive.typeName || '-' }}</span>
          </el-form-item>
          <el-form-item label="文件名称:">
            <span>{{ currentArchive.docName || '-' }}</span>
          </el-form-item>
          <el-form-item label="档案编号:">
            <span>{{ currentArchive.docNum || '未设置' }}</span>
          </el-form-item>
          <el-form-item label="状态:">
            <el-tag :type="statusType(currentArchive.status)" size="mini">{{ statusText(currentArchive.status)
              }}</el-tag>
          </el-form-item>
          <el-form-item label="提交时间:">
            <span>{{ currentArchive.createTime || '-' }}</span>
          </el-form-item>
          <el-form-item label="备注:">
            <span>{{ currentArchive.remark || '-' }}</span>
          </el-form-item>
          <el-form-item label="档案图片:">
            <div v-if="archiveUrls(currentArchive).length" class="archive-file-list">
              <el-image v-for="url in archiveUrls(currentArchive)" :key="url" :src="url"
                :preview-src-list="archiveUrls(currentArchive)" fit="contain" class="archive-image" lazy />
            </div>
            <span v-else>暂无档案图片</span>
          </el-form-item>
        </el-form>
      </div>
      <div v-if="currentArchive && String(currentArchive.status) === '0'" slot="footer">
        <el-button type="warning" icon="el-icon-close" @click="checkCurrentArchive(2)">驳回</el-button>
        <el-button type="success" icon="el-icon-check" @click="checkCurrentArchive(1)">通过</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getTeacherArchivesTypeList,
  updateTeacherArchivesDocNum,
  deleteTeacherArchives,
  archivingTeacherArchives,
  addTeacherArchivesLog,
  checkTeacherArchives,
} from '@/config/api';

const parsePageData = (res) => {
  if (res.resCode == 200) res.code = 0;
  const data = res.data || {};
  if (Array.isArray(data)) {
    res.count = data.length;
    res.data = data;
  } else {
    res.count = data.total || data.count || 0;
    res.data = data.records || data.list || [];
  }
  return res;
};

const getListData = (data) => {
  if (Array.isArray(data)) return data;
  return data.records || data.list || [];
};

export default {
  name: 'TeacherArchivesList',
  data () {
    return {
      typeOptions: [],
      choose: [],
      detailVisible: false,
      currentArchive: null,
      table: {
        url: '/teacherArchives/getArchivesList',
        method: 'GET',
        where: {},
        parseData: parsePageData,
      },
    };
  },
  created () {
    this.loadTypes();
  },
  methods: {
    getRowKey (row) {
      return row.id;
    },
    loadTypes () {
      getTeacherArchivesTypeList({ typeName: '', parentId: 0 }).then((res) => {
        if (res.data.resCode != 200) return this.$message.error(res.data.resMsg);
        const majors = getListData(res.data.data);
        const hasChildren = majors.some((item) => item.children && item.children.length);
        if (hasChildren) {
          this.typeOptions = this.flattenLeaves(majors);
          return;
        }
        Promise.all(majors.map((item) => getTeacherArchivesTypeList({ typeName: '', parentId: item.id })))
          .then((responses) => {
            const minors = [];
            responses.forEach((response, index) => {
              if (response.data.resCode == 200) {
                getListData(response.data.data).forEach((item) => {
                  minors.push(Object.assign({}, item, { parentName: majors[index].typeName }));
                });
              }
            });
            this.typeOptions = minors;
          })
          .catch((e) => this.$message.error(e.message));
      });
    },
    flattenLeaves (list, parentName) {
      const result = [];
      (list || []).forEach((item) => {
        if (item.children && item.children.length) {
          result.push(...this.flattenLeaves(item.children, item.typeName));
        } else {
          result.push(Object.assign({}, item, { parentName: item.parentName || parentName }));
        }
      });
      return result;
    },
    typeLabel (item) {
      return item.parentName ? `${item.parentName} / ${item.typeName}` : item.typeName;
    },
    resetSearch () {
      this.table.where = {};
      this.$refs.table.reload();
    },
    isArchived (row) {
      return String(row.status) === '3';
    },
    canSelectForArchive (row) {
      return String(row.status) === '1' && !this.isArchived(row);
    },
    getArchivableRows (rows) {
      return (rows || []).filter((row) => this.canSelectForArchive(row));
    },
    viewArchive (row) {
      addTeacherArchivesLog({ id: row.id });
      this.currentArchive = row;
      this.detailVisible = true;
    },
    archiveUrls (row) {
      return String((row && row.docUrl) || '')
        .split(',')
        .map((url) => url.trim())
        .filter(Boolean);
    },
    checkCurrentArchive (status) {
      if (!this.currentArchive) return;
      this.checkArchive(this.currentArchive, status);
    },
    setDocNum (row) {
      if (!this.isArchived(row)) {
        this.$message.warning('请先归档档案，再设置档案编号');
        return;
      }
      this.$prompt('请输入档案编号', '设置档案编号', {
        inputValue: row.docNum || '',
        inputPlaceholder: '请输入档案编号',
        inputValidator: (value) => !!value || '档案编号不能为空',
      })
        .then(({ value }) => {
          const formData = new FormData();
          formData.append('id', row.id);
          formData.append('docNum', value);
          return updateTeacherArchivesDocNum(formData);
        })
        .then((res) => {
          if (res.data.resCode == 200) {
            this.$message.success(res.data.resMsg || '设置成功');
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.resMsg);
          }
        })
        .catch(() => 0);
    },
    checkArchive (row, status) {
      if (String(row.status) !== '0') {
        this.$message.warning('当前档案不是待审核状态');
        return;
      }
      const submit = (reason) => {
        const formData = new FormData();
        formData.append('id', row.id);
        formData.append('status', status);
        if (reason) formData.append('reason', reason);
        return checkTeacherArchives(formData);
      };
      if (status === 1) {
        this.$confirm('确定通过该教师档案吗？', '审核确认', { type: 'warning' })
          .then(() => submit(''))
          .then((res) => this.handleActionResult(res, true))
          .catch(() => 0);
      } else {
        this.$prompt('请输入驳回原因', '审核档案', {
          inputValidator: (value) => !!value || '请输入驳回原因',
        })
          .then(({ value }) => submit(value))
          .then((res) => this.handleActionResult(res, true))
          .catch(() => 0);
      }
    },
    archive (row) {
      const rows = this.getArchivableRows([row]);
      if (!rows.length) {
        this.$message.warning('只有已通过且未归档的档案可以归档');
        return;
      }
      this.archiveRows(rows);
    },
    archiveSelected () {
      const rows = this.getArchivableRows(this.choose);
      if (!rows.length) {
        this.$message.warning('请至少选择一条已通过且未归档的档案');
        return;
      }
      this.archiveRows(rows);
    },
    archiveRows (rows) {
      const message = rows.length === 1 ? '确定归档该教师档案吗？' : `确定归档选中的 ${rows.length} 条教师档案吗？`;
      this.$confirm(message, '归档确认', { type: 'warning' })
        .then(() => {
          const formData = new FormData();
          formData.append('ids', rows.map((row) => row.id).join(','));
          return archivingTeacherArchives(formData);
        })
        .then((res) => this.handleActionResult(res))
        .catch(() => 0);
    },
    deleteArchive (row) {
      const formData = new FormData();
      formData.append('id', row.id);
      deleteTeacherArchives(formData).then((res) => this.handleActionResult(res));
    },
    handleActionResult (res, closeDetail) {
      if (res.data.resCode == 200) {
        this.$message.success(res.data.resMsg || '操作成功');
        if (closeDetail) {
          this.detailVisible = false;
          this.currentArchive = null;
        }
        this.choose = [];
        this.$refs.table.reload();
      } else {
        this.$message.error(res.data.resMsg);
      }
    },
    statusText (status) {
      return { 0: '待审核', 1: '已通过', 2: '未通过', 3: '已归档', '-1': '已删除' }[String(status)] || '未知';
    },
    statusType (status) {
      return { 0: 'warning', 1: 'success', 2: 'danger', 3: 'success', '-1': 'info' }[String(status)] || 'info';
    },
  },
};
</script>

<style scoped>
.ele-block {
  width: 100%;
}

.archive-file-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.archive-image {
  width: 110px;
  height: 110px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  cursor: pointer;
}
</style>
